import Decorations from './DecorationUtils';
import Editor from './EditorUtils';
import Marks from './MarkUtils';
import Path from './PathUtils';
import Selection from './SelectionUtils';
import Transforms from './TransformsUtils';
import Attachments from './AttachmentUtils';
import { Utils as List } from '../plugins/ListPlugin/ListPlugin';
import { TableUtils as Table } from '../plugins/TablePlugin/TablePlugin';
import Rendering from './RenderingUtils';
import Operations from './OperationsUtils';
import Nodes from './NodeUtils';

export default {
  Decorations,
  Editor,
  List,
  Marks,
  Path,
  Selection,
  Table,
  Transforms,
  Attachments,
  Rendering,
  Operations,
  Nodes,
};
